<div class="survey-frame relative flex flex-col h-full w-full overflow-hidden rounded-lg">
  <div class="survey-card relative flex flex-col h-[var(--survey-card-height,76%)] min-h-0 my-auto w-full max-w-[960px] mx-auto bg-white rounded-xl shadow-md overflow-hidden">
    <header class="flex items-center justify-between gap-3 px-5 pt-4 lg:px-8 lg:pt-6">
      <span class="text-sm lg:text-base font-semibold text-primary">
        Pregunta · {{ index + 1 }}/{{ questions.length }}
      </span>
      <button
        type="button"
        class="flex items-center gap-2 px-3 py-1.5 rounded-md border-1 border-solid border-gray-200 bg-white text-sm text-gray-800 cursor-pointer hover:bg-gray-50"
        (click)="panelOpen = true"
      >
        <mat-icon class="mdi mdi-format-list-bulleted text-lg leading-none" aria-hidden="true"></mat-icon>
        Ver preguntas
      </button>
    </header>

    <div class="relative flex-1 min-h-0 flex items-center">
      <button
        type="button"
        class="survey-arrow survey-arrow--prev"
        aria-label="Pregunta anterior"
        [disabled]="!canGoPrev"
        (click)="go(index - 1)"
      >
        <mat-icon class="mdi mdi-chevron-left text-xl leading-none" aria-hidden="true"></mat-icon>
      </button>

      <!-- Virtual: solo unas pocas slides montadas, sea cual sea el número de preguntas -->
      <swiper-container #deck init="false" class="survey-deck block w-full h-full">
        <swiper-slide
          *ngFor="let question of virtualData.slides; let i = index; trackBy: trackBySlide"
          [attr.data-swiper-slide-index]="virtualData.from + i"
          [style.left.px]="virtualData.offset"
          class="survey-slide"
        >
          <!--
            Scroll on the outer box, centring on an inner wrapper with `my-auto`. Centring the scroll
            box itself (`justify-center`) pushes the overflow above the top edge, where it cannot be
            scrolled to: a long question would lose its first lines.
          -->
          <div class="h-full w-full flex flex-col px-6 py-4 lg:px-14 overflow-y-auto">
            <div class="my-auto w-full">
              <ng-container
                *ngTemplateOutlet="questionTemplate; context: { $implicit: question, index: virtualData.from + i }"
              ></ng-container>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>

      <button
        type="button"
        class="survey-arrow survey-arrow--next"
        aria-label="Pregunta siguiente"
        [disabled]="!canGoNext"
        (click)="go(index + 1)"
      >
        <mat-icon class="mdi mdi-chevron-right text-xl leading-none" aria-hidden="true"></mat-icon>
      </button>
    </div>

    <!-- avance: una marca por pregunta; cada una también navega a su pregunta -->
    <div class="flex gap-1.5 px-5 pb-4 lg:px-8 lg:pb-6" *ngIf="questions.length > 1">
      <button
        *ngFor="let question of questions; let i = index"
        type="button"
        class="survey-segment flex-1 h-1.5 rounded-full border-none p-0 cursor-pointer"
        [ngClass]="segmentClass(i)"
        [attr.aria-label]="'Ir a la pregunta ' + (i + 1)"
        (click)="go(i)"
      ></button>
    </div>
  </div>

  <app-survey-question-panel
    [open]="panelOpen"
    [questions]="questions"
    [index]="index"
    [labelOf]="labelOf"
    [answeredOf]="answeredOf"
    [title]="panelTitle"
    [sectionLabel]="panelSectionLabel"
    (select)="onPanelSelect($event)"
    (closed)="panelOpen = false"
  ></app-survey-question-panel>
</div>
